import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/questionnaire';

export default {
  mixins: [entryMixin],
  langs,
  langName: 'questionnaire',
};
